import { render, staticRenderFns } from "./personal-information-agree.modal.vue?vue&type=template&id=243e2e50&"
import script from "./personal-information-agree.modal.vue?vue&type=script&lang=ts&"
export * from "./personal-information-agree.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports